import { createFileRoute } from "@tanstack/react-router";

import { orNotFound } from "../components/prenoms/load";
import { YearDepartmentPage, yearDepartmentHead } from "../components/prenoms/year-pages";
import { namesApi } from "../lib/api";
import { seo } from "../lib/head";

export const Route = createFileRoute("/prenoms/annee/$year/$department")({
  staticData: { ssr: true },
  loader: ({ context, params }) =>
    orNotFound(() =>
      context.queryClient.query({
        queryKey: ["prenoms-year-department", params.year, params.department],
        queryFn: () => namesApi.yearDepartment(params.year, params.department),
        staleTime: "static",
      }),
    ),
  head: ({ loaderData }) => (loaderData ? seo(yearDepartmentHead(loaderData)) : {}),
  component: Page,
});
function Page() {
  return <YearDepartmentPage data={Route.useLoaderData()} />;
}
